import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type AncStatTileVariant =
    | 'neutral'
    | 'negative'
    | 'info'
    | 'positive'
    | 'alert';

/**
 * Snapshot tile for the inventory overview: a small caption label above a large
 * tabular figure, on a tonal background. Used in the "Inventory snapshot" grid.
 */
@Component({
    selector: 'lib-anc-stat-tile',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-stat-tile.component.html',
    styleUrls: ['./anc-stat-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncStatTileComponent {
    /** Tile caption (run through translate). */
    label = input<string>('');
    /** Figure shown large with tabular numerals. */
    value = input<string>('');
    /** Tonal treatment. */
    variant = input<AncStatTileVariant>('neutral');
}
